export default "/static/dashboard/build/app/img/v2/9a658f77392f6d0b2fddad0ec1db4d79.png";